export enum SelectedPuppetTab {
  TRADE = 0,
  FUNDS = 1,
  CASH = 2,
}

export enum CAPITAL_OPERATIONS {
  sell = 'sell',
  buy = 'buy',
}
